export const HERO = {
    default: {
        title: "Land Your Next Offer with AI by Your Side",
        subtitle: "Your undetectable copilot feeds you real-time answers to behavioral & coding questions — walk in prepared, walk out hired.",
        subtitleShort: "Real-time AI answers in your interviews — walk in prepared, walk out hired.",
        highlight: "hired",
        badges: ["Undetectable", "1-Second Answers", "Powered by Opus 4.8"]
    },
    assistant: {
        title: "Ace Every Call with AI by Your Side",
        subtitle: "Real-time answers for behavioral & technical questions — stay calm, sound sharp, and close with confidence.",
        subtitleShort: "Real-time AI answers on every call — stay calm and close with confidence.",
        badges: ["Screen-Aware", "1-Second Answers", "Powered by Opus 4.8"]
    }
};
